import CheckpointVisibilitySlideSelect from '../slider/CheckpointVisibilitySlideSelect'
import { IProjectCheckpoint } from '../../projectCheckpoints.types'
import projectCheckpointsApi from '../../projectCheckpoints.api'
import { useCallback } from 'react'
import eventBus from 'services/eventBus'

interface IProps {
  item: IProjectCheckpoint
}

const CheckpointStatusCell = (props: IProps) => {
  const selectedOption = props.item.isVisible !== false ? 'visible' : 'hidden'

  const handleVisibilityChange = useCallback((isVisible: boolean) => {
    projectCheckpointsApi.update({ isVisible }, props.item.id).then((resp) => {
      if (resp.status === 'success') {
        eventBus.pub('ntf.message', {
          type: 'info',
          message: isVisible ? 'Контрольная точка показана' : 'Контрольная точка скрыта',
        })
        eventBus.pub('projectCheckpoints.updated', { updates: resp.body, id: props.item.id })
      }
    })
  }, [])

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <CheckpointVisibilitySlideSelect
        selectedOption={selectedOption}
        onSelect={(value) => handleVisibilityChange(value === 'visible')}
      />
    </div>
  )
}

export default CheckpointStatusCell
